import ExhibitionTypeSelect from "./exhibition-type-select";


const ExhibitionFormItems = {
    ExhibitionTypeSelect: ExhibitionTypeSelect,
};

export default ExhibitionFormItems;